// Port of api/fuel/app/classes/insights/plays/locations.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'locations',
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var limit = detail ? 100 : 5
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND play_players = ' + players : ''

        var locationsRaw = Util.queryFast(
            'SELECT LOWER(TRIM(p.play_location)) AS name,' +
            ' SUM(p.play_count) AS count' +
            ' FROM play p' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            " AND p.play_location <> ''" +
            ' AND play_date >= ' + range.start +
            ' AND play_date < ' + range.end +
            sqlCount +
            ' GROUP BY LOWER(TRIM(p.play_location))'
        )

        var locations = locationsRaw.slice().sort(function(a, b) {
            var av = parseInt(a.count, 10) || 0
            var bv = parseInt(b.count, 10) || 0
            if (av !== bv) return bv - av
            return String(a.name || '').localeCompare(String(b.name || ''))
        })
        locations = locations.slice(0, limit)

        return {
            locations: locations
        }

    }
})
